var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5247 10.6667C12.5024 9.50566 13.0381 8.03635 13.037 6.51852C13.037 2.91844 10.1186 0 6.51852 0C2.91844 0 0 2.91844 0 6.51852C0 10.1186 2.91844 13.037 6.51852 13.037C8.03635 13.0381 9.50566 12.5024 10.6667 11.5247L15.162 16L16 15.162L11.5247 10.6667ZM6.51852 11.8519C3.573 11.8519 1.18519 9.46404 1.18519 6.51852C1.18519 3.573 3.573 1.18519 6.51852 1.18519C9.46404 1.18519 11.8519 3.573 11.8519 6.51852C11.8486 9.46268 9.46268 11.8486 6.51852 11.8519Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.fa4f9e91c4deff54edea3353bd9197bf.svg";
export { ForwardRef as ReactComponent };